import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useWorkstations } from '@/hooks/v1';
import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { LINE_FIELD, WORKSTATION_FIELD } from './constants';
import { FieldFormItem } from './styles';

const { useFormInstance, useWatch } = Form;

export function Workstation(): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch(LINE_FIELD, form);
	const workstationId = useWatch(WORKSTATION_FIELD, form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations({
		organization_id: organization?.id,
		company_id: company?.id,
		line_id: lineId
	});

	function handleSelectWorkstation(id?: string): void {
		form.setFieldValue(WORKSTATION_FIELD, id);
	}

	function handleClearWorkstations(): void {
		handleSelectWorkstation(undefined);
	}

	const isDisabled = isLoading || isFetching || isError || !lineId;

	return (
		<FieldFormItem name={WORKSTATION_FIELD} label={I18n.get('Workstation')} labelCol={{ span: 24 }}>
			<WorkstationSelect
				lineId={lineId}
				loading={isFetching}
				disabled={isDisabled}
				workstations={workstations}
				workstationId={workstationId}
				fieldName={WORKSTATION_FIELD}
				allowCreation={false}
				handleSelectWorkstation={handleSelectWorkstation}
				handleClearWorkstations={handleClearWorkstations}
			/>
		</FieldFormItem>
	);
}
